import { render, staticRenderFns } from "./family_member_yukon.vue?vue&type=template&id=08ea9b87&"
import script from "./family_member_yukon.vue?vue&type=script&lang=js&"
export * from "./family_member_yukon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports